import { useEffect, useRef, useState } from "react";
import { AdditionalProject } from "../types/project";
export function useProjectShelf(additional: AdditionalProject[]) {
  const [visible, setVisible] = useState(2);
  const [loading, setLoading] = useState(false);
  const mounted = useRef(true);
  const shelf = useRef<HTMLDivElement>(null);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  async function loadMore() {
    if (loading) return;
    setLoading(true);
    const start = visible;
    await Promise.all(
      additional.slice(start, start + 2).map((p) =>
        p.image
          ? new Promise<void>((resolve) => {
              const image = new Image();
              const timeout = setTimeout(resolve, 5000);
              const finish = () => {
                clearTimeout(timeout);
                resolve();
              };
              image.onload = finish;
              image.onerror = finish;
              image.src = p.image!;
            })
          : Promise.resolve(),
      ),
    );
    if (mounted.current) {
      const next = Math.min(start + 2, additional.length);
      setVisible(next);
      setLoading(false);
      if (next === additional.length)
        requestAnimationFrame(() =>
          shelf.current
            ?.querySelectorAll<HTMLAnchorElement>(".archive-row")
            [start]?.focus({ preventScroll: true }),
        );
    }
  }
  return { visible, loading, shelf, loadMore };
}
